export default __webpack_public_path__ + "static/media/Heidi 9781408336472.3f0b38b7.jpg";